import update from 'react-addons-update';
import { makeActionCreator } from 'crazyEditor/redux/helpers';
import { UPDATE_DESKTOP_ELEMENT, ADD_DESKTOP_ELEMENT } from '../element/actions/desktopElementActions';

import _ from 'lodash';

export default function reducer(state = {}, action = {}) {
  let templateTag;
  switch (action.type) {
    case UPDATE_DESKTOP_ELEMENT:
      templateTag = action.templateTag;
      break;
    default:
      break;
  }
  if (templateTag) {
    const text = _.get(action, 'elementProps.data.text');
    return update(state, {
      [templateTag]: {
        $set: text,
      }
    });
  }
  return state;
}
